/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_SummaryInputs */

const en_case_detail_summary = /** @type {(inputs: Case_Detail_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary`)
};

const pt_br2_case_detail_summary = /** @type {(inputs: Case_Detail_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo`)
};

/**
* | output |
* | --- |
* | "Summary" |
*
* @param {Case_Detail_SummaryInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_summary = /** @type {((inputs?: Case_Detail_SummaryInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_SummaryInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_summary(inputs)
	return pt_br2_case_detail_summary(inputs)
});